import React from "react"

import SideNavigation from "./SideNavigation"

const MobileUtilityNavigation = ({ organizationSlug }: { organizationSlug?: string }) => {
  return (
    <>
      {organizationSlug && (
        <SideNavigation.Item
          id="mobile-nav-org-discover"
          title="Discover AppSignal"
          icon="fa-lightbulb-on"
          type="link"
          href={`/${organizationSlug}/discover`}
        />
      )}
      <SideNavigation.Item
        id="mobile-nav-assigned"
        title="Assigned issues"
        icon="fa-inbox"
        type="link"
        href="/assignments"
      />
      <SideNavigation.Item
        id="mobile-nav-help"
        title="Help & docs"
        icon="fa-book"
        type="link"
        href="https://docs.appsignal.com/getting-started"
        target="_blank"
        rel="noopener noreferrer"
      />
    </>
  )
}

export default MobileUtilityNavigation
